import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { testHomepageRedesign } from './events/abTesting';

export const useHomepageTest = () => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    const isHomepage = router.pathname === '/';
    const { slug } = router.query;

    if (isHomepage && typeof slug === 'string') {
      testHomepageRedesign({
        test_variant: 'variant',
        real_path: slug
      });
    }
  }, [router.isReady, router.pathname, router.query.slug, router.query]);
};
